import { fetchCloudSessionMeta } from './fetch-session-meta.js';
import type { CloudFetchParams } from './types.js';

export async function resolveParentSessionIdForChild(
  params: CloudFetchParams & { childSessionId: string },
): Promise<{ ok: true; parentSessionId: string } | { ok: false; error: string }> {
  const meta = await fetchCloudSessionMeta({
    sessionId: params.childSessionId,
    cloudApiBaseUrl: params.cloudApiBaseUrl,
    getCloudAccessToken: params.getCloudAccessToken,
  });
  if (!meta.ok) return meta;
  const parent = meta.data.parentSessionId?.trim() ?? '';
  if (!parent) {
    return {
      ok: false,
      error: `Session ${params.childSessionId} has no parent session history. It was not forked from another session (no parent_session_id). Pass the forked child session id as sessionId, not the parent session id.`,
    };
  }
  return { ok: true, parentSessionId: parent };
}
